export { RippleDirective } from './ripple-effect.directive';
export { RippleModule } from './ripple.module';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/free/ripple/index.ts